import { render, staticRenderFns } from "./cancelTrip-driver.vue?vue&type=template&id=15139f56&scoped=true&"
import script from "./cancelTrip-driver.vue?vue&type=script&lang=js&"
export * from "./cancelTrip-driver.vue?vue&type=script&lang=js&"
import style0 from "./cancelTrip-driver.vue?vue&type=style&index=0&id=15139f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15139f56",
  null
  
)

export default component.exports